// loginRegisterConstants.js
'use strict';

export const Entry = {
  LOGIN: 'login',
  REGISTER: 'register',
};

export const AuthId = {
  FACEBOOK: 'facebook-oauth2',
  TWITTER: 'twitter-oauth1',
  GOOGLE: 'google-oauth2',
  APPLE_ID: 'apple-id',
  PASSWORD: 'password',
  EMAIL: 'email',
  SMS: 'sms',
  DISCORD: 'discord',
  EMAIL_UNVERIFIED: 'email-unverified',
};
